import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { ShowPriceInComponent } from './show-price-in.component';

@NgModule({
  imports: [CommonModule, HttpClientModule, ModalModule.forRoot()],
  declarations: [ShowPriceInComponent],
  exports: [ShowPriceInComponent]
})
export class ShowPriceInModule {}
